import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPageTitle } from "navigation/routeTitles";

/**
 * Component that automatically updates document.title based on the current route
 * Must be placed inside the Router component
 */
const RouteTitleHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const title = getPageTitle(location.pathname);
    document.title = title;
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default RouteTitleHandler;